import {setLanguage} from './lang'
import $ from "jquery"
let lang = 'ko';

$(document).ready(function(){
    $('.main menu ul li').eq(0).addClass('on');
    lang = getLang()
    setLanguage(lang)

    //maintext
    $('.main>div article').eq(0).find('h2').stop().animate({'margin-right':'0','opacity':'1'},800)
    $('.main>div article').eq(0).find('h5').stop().animate({'margin-right':'0','opacity':'1'},800)
    $('.main>div article').eq(0).find('.mt').stop().animate({'right':'0','opacity':'0.9'},800)

    //main menu click
    $('.main menu ul li').click(function(){
        var i = $(this).index();

        //text 보이기
        $('.main>div article').removeClass('on');
        $('.main>div article').eq(i).addClass('on');

        //메뉴 on
        $('.main menu ul li').removeClass('on');
        $('.main menu ul li').eq(i).addClass('on');

        //text animate 보이기
        $('.main>div article').find('h2').stop().animate({'margin-right':'-100px','opacity':'0'},800)
        $('.main>div article').find('h5').stop().animate({'margin-right':'-50px','opacity':'0'},800)
        $('.main>div article').find('.mt').stop().animate({'right':'-30px','opacity':'0'},800)

        $('.main>div article').eq(i).find('h2').stop().animate({'margin-right':'0','opacity':'1'},800)
        $('.main>div article').eq(i).find('h5').stop().animate({'margin-right':'0','opacity':'0.9'},800)
        $('.main>div article').eq(i).find('.mt').stop().animate({'right':'0','opacity':'1'},800)
    })

    //스크롤
    $(window).scroll(function(){
        var mh = $('.main').height();
        var st = $(this).scrollTop();
        var ma = 1;
        var mb = ma*mh;

        //contents 보이기
        if(st>=mb*1.5){
            $('.con1 .con1_bg').css({'opacity':'0.8'})
            $('.con1 figure').css({'opacity':'1'})
        }else if(st<mb*2.4){
            $('.con1 .con1_bg`, .con1 figure').css({'opacity':'0.2'})
        }
        if(st>=mb*2.5){
            $('.con2 .con2_bg, .con2 figure').css({'opacity':'1'})
            $('.con1 .con1_bg, .con1 figure, .con3 .con3_bg, .con3 figure').css({'opacity':'0.1'})
        }else if(st<mb*3.4){
            $('.con2 .con2_bg, .con2 figure').css({'opacity':'0.2'})
        }
        if(st>=mb*3.5){
            $('.con3 .con3_bg').css({'opacity':'0.4'})
            $('.con3 figure').css({'opacity':'1'})
            $('.con2 .con2_bg, .con2 figure').css({'opacity':'0.2'})
        }
    })
})

//사용자 언어 정보 추출
function getLang() {
    var userLang = navigator.language || navigator.userLanguage;

    if(userLang.toLowerCase().includes('ko') || userLang.toLowerCase().includes('kr'))
    {
        userLang = 'ko'
    }

    if(userLang.toLowerCase().includes('en') || userLang.toLowerCase().includes('us'))
    {
        userLang = 'en'
    }
    return userLang;
}